// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import apiClient from "../config/api";
import { handleApiCall } from "../utils/apiHelper";

const withTenant = (tenantId) => (tenantId ? { tenant_id: tenantId } : {});

const reportingGet = (path, context, tenantId) =>
  handleApiCall(
    () => apiClient.get(path, { params: withTenant(tenantId) }),
    context,
  );

export const fetchOverviewKPIs = (tenantId = null) =>
  reportingGet(
    "/reporting/overview-kpis",
    "Error fetching overview KPIs",
    tenantId,
  );

export const fetchSeasonalData = (tenantId = null) =>
  reportingGet(
    "/reporting/seasonal-data",
    "Error fetching seasonal data",
    tenantId,
  );

export const fetchCategoryBreakdown = (tenantId = null) =>
  reportingGet(
    "/reporting/category-breakdown",
    "Error fetching category breakdown",
    tenantId,
  );

export const fetchForecastData = (tenantId = null) =>
  reportingGet(
    "/reporting/forecast-data",
    "Error fetching forecast data",
    tenantId,
  );

export const fetchSeasonalityFactors = (tenantId = null) =>
  reportingGet(
    "/reporting/seasonality-factors",
    "Error fetching seasonality factors",
    tenantId,
  );

export const fetchGrowthRates = (tenantId = null) =>
  reportingGet(
    "/reporting/growth-rates",
    "Error fetching growth rates",
    tenantId,
  );

export const fetchScenarioAnalysis = (tenantId = null) =>
  reportingGet(
    "/reporting/scenario-analysis",
    "Error fetching scenario analysis",
    tenantId,
  );

export const fetchAllFinancialData = async (tenantId = null) => {
  const [overviewKPIs, seasonalData, categoryBreakdown] = await Promise.all([
    fetchOverviewKPIs(tenantId),
    fetchSeasonalData(tenantId),
    fetchCategoryBreakdown(tenantId),
  ]);
  return { overviewKPIs, seasonalData, categoryBreakdown };
};

export const fetchAllForecastData = async (tenantId = null) => {
  const [forecastData, seasonalityFactors, growthRates, scenarioAnalysis] =
    await Promise.all([
      fetchForecastData(tenantId),
      fetchSeasonalityFactors(tenantId),
      fetchGrowthRates(tenantId),
      fetchScenarioAnalysis(tenantId),
    ]);
  return { forecastData, seasonalityFactors, growthRates, scenarioAnalysis };
};
